<template>
  <div>
    <Header></Header>
    <div class="banner">
      <div class="word">
        <div class="wordtitle">
          开放服务
        </div>
        <div class="smallitle">
          对外提供开放服务入口，企业用户可从工业互联网战略咨询服务、智能制造软硬件集成服务、 实训基地及培训服务、开放API能力这四大方面提出疑问，平台可解答相关疑问。
        </div>
      </div>
    </div>
    <div class="demand">
      <div>
        <div class="title">获取平台开放服务</div>
        <div class="list">
          <div class="one">
            <img src="../../assets/images/s01@2x.png" alt="" width="173px" height="173px">
            <div>注册登录</div>
          </div>
          <div class="two">
            <img src="../../assets/images/s02@2x.png" alt="" width="173px" height="173px">
            <div>选择您需要的服务</div>
          </div>
          <div class="three">
            <img src="../../assets/images/s03@2x.png" alt="" width="173px" height="173px">
            <div>开启您的工业互联网旅程</div>
          </div>
        </div>
        <div class="btn">
          <div class="subDemand" @click="demand">服务申请</div>
        </div>
      </div>
    </div>
    <div class="serviceList">
      <div>
        <div :class="[{'activeBG':active==index}]" v-for="(item, index) in pagaData" :key="index" @mouseover="mouseOver(index)" @mouseleave="mouseLeave()">
          <img v-if="index == 0" :src="active == index ? require('../../assets/images/st01@2x.png') : require('../../assets/images/st1@2x.png')" width="72px" height="72px">
          <img v-if="index == 1" :src="active == index ? require('../../assets/images/st02@2x.png') : require('../../assets/images/st2@2x.png')" width="68px" height="68px">
          <img v-if="index == 2" :src="active == index ? require('../../assets/images/st03@2x.png') : require('../../assets/images/st3@2x.png')" width="67px" height="67px">
          <img v-if="index == 3" :src="active == index ? require('../../assets/images/st04@2x.png') : require('../../assets/images/st4@2x.png')" width="82px" height="68px">
          <div class="title" :class="[{'activeBG1':active==index}]">{{item.title}}</div>
          <div class="content" :class="[{'activeBG1':active==index}]">{{item.content}}</div>
        </div>
      </div>
    </div>
    <serviceDialog :dialogData='dialogData2' @valueData="childrenData2"></serviceDialog>
    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import serviceDialog from '@/components/serviceDialog.vue'
  import {
    serverUrl
  } from '@/utils/server.js'
  import {

  } from '@/api/api'
  export default {
    data() {
      return {
        pagaData: [
          {
            title: '工业互联网战略咨询服务',
            content: '工业互联网体系架构，标识注册解析应用，标识应用推广服务，企业人才服务等不同领域的咨询服务',
            img: require('../../assets/images/st1@2x.png')
          },
          {
            title: '软硬件集成服务',
            content: '为原料生产行业、成品制造行业、物流运输行业等诸多领域提供服务，实现从软件（生产管理、人员管理、资产管理、物流管理、仓库管理等）、硬件（RFID产品、无线数据传输产品、环境监测仪、打印机）等众多领域的集成、实施工作。',
            img: require('../../assets/images/st2@2x.png')
          },
          {
            title: '实训基地及培训服务',
            content: '提供实训基地以及线上环境，对企业开展标识化，数字化培训。',
            img: require('../../assets/images/st3@2x.png')
          },

          {
            title: '开放API服务',
            content: '搭建API服务工作站，针对规模化的标识数据进行统计和分析，对外提供可认证和授权的数据服务。',
            img: require('../../assets/images/st4@2x.png')
          }
        ],
        active: null,
        dialogData2: false,
        serverUrl: serverUrl.baseURL
      }
    },
    components: {
      Header,
      Footer,
      serviceDialog
    },
    mounted() {

    },
    methods: {
      demand() {
        this.dialogData2 = true
      },
      childrenData2(val) {
        this.dialogData2 = val
      },
      mouseOver(index) {
        this.active = index
        console.log(index)
      },
      mouseLeave() {
        this.active = null
      },
    }
  }
</script>

<style scoped>
  .banner {
    width: 100%;
    height: 480px;
    background: url(../../assets/images/service@2x.png) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }

  .word {
    width: 1300px;
    margin: 160px auto 0;
  }

  .smallitle {
    width: 653px;
    height: 40px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #E1E2E6;
    line-height: 24px;
    margin-top: 40px;
  }

  .wordtitle {
    font-size: 42px;
    font-family: Source Han Sans CN;
    color: #FFFFFF;
    line-height: 46px;
  }

  .demand {
    height: 715px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
  }

  .demand .title {
    font-size: 48px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    text-align: center;
    margin-bottom: 80px;
  }

  .list {
    display: flex;
    justify-content: space-between;
  }

  .list>div {
    text-align: center;
    width: 270px;
  }

  .two {
    margin: 0 295px;
  }

  .list>div>div {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
    margin-top: 20px;
  }

  .btn {
    display: flex;
    justify-content: center;
    margin-top: 70px;
  }

  .subDemand {
    width: 300px;
    height: 76px;
    background: #0F5EFF;
    border-radius: 16px;
    font-size: 28px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 76px;
    cursor: pointer;
  }

  .serviceList {
    height: 940px;
    background: #FAFBFC;
    display: flex;
    align-items: center;
  }

  .serviceList > div {
    width: 1440px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
  }

  .serviceList > div > div {
    width: 699px;
    height: 340px;
    box-sizing: border-box;
    padding: 45px 60px;
    cursor: pointer;
  }

  .activeBG {
    background: url(../../assets/images/activeBG@2x.png) top center no-repeat !important;
  }

  .serviceList > div > div:nth-child(1) {
    margin-right: 40px;
    background: url(../../assets/images/sbg1@2x.png) top center no-repeat;
    background-size: cover;
  }
  .serviceList > div > div:nth-child(2) {
    background: url(../../assets/images/sbg2@2x.png) top center no-repeat;
    background-size: cover;
  }
  .serviceList > div > div:nth-child(3) {
    margin-top: 40px;
    margin-right: 40px;
    background: url(../../assets/images/sbg3@2x.png) top center no-repeat;
    background-size: cover;
  }
  .serviceList > div > div:nth-child(4) {
    margin-top: 40px;
    background: url(../../assets/images/sbg4@2x.png) top center no-repeat;
    background-size: cover;
  }

  .serviceList .title {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    margin: 35px 0 25px;
  }

  .serviceList .content {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: #7D889B;
    line-height: 26px;
  }

  .activeBG1 {
    color: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/service/ServiceDetails.vue